import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Search() {
  const [products, setProducts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch("https://beadastra-a7epexf5c5b7dng0.canadacentral-01.azurewebsites.net/products");
        const data = await res.json();
        setProducts(data);
        setFiltered(data);
      } catch (error) {
        console.error("Error cargando productos:", error);
      }
    };
    fetchProducts();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const category = params.get("category");
    if (category) {
      const filteredByCategory = products.filter((p) =>
        p.category?.toLowerCase().includes(category.toLowerCase())
      );
      setFiltered(filteredByCategory);
    }
  }, [location.search, products]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setQuery(value);
    const filteredByName = products.filter((p) =>
      p.name.toLowerCase().includes(value.toLowerCase())
    );
    setFiltered(filteredByName);
  };

  const getDefaultPackPrice = (p) => {

  const has1 = Boolean(p.pack1Image);
  const has3 = Boolean(p.pack3Image);
  const has5 = Boolean(p.pack5Image);

  // Si SOLO existe pack 3 → usar lógica especial
  if (!has1 && has3 && !has5) {
    const unitWithDiscount = p.price * 0.90;  // 10% descuento
    const total = unitWithDiscount * 3;       // x3 unidades
    return total;
  }

  // Caso normal = precio unitario
  return p.price;
};

const isOnly3Pack = (p) => {
  const has1 = Boolean(p.pack1Image);
  const has3 = Boolean(p.pack3Image);
  const has5 = Boolean(p.pack5Image);

  return !has1 && has3 && !has5;
};


  return (
    <section id="products" className=" px-4 max-w-7xl mx-auto" >
      <h2 className="text-3xl md:text-4xl font-bold text-center uppercase mb-12 tracking-wide">
        Nuestros Productos
      </h2>
{/* 
      <div className="mb-8 flex justify-center">
        <input
          type="text"
          value={query}
          onChange={handleSearch}
          placeholder="Buscar por nombre..."
          className="w-full max-w-md px-4 py-2 border border-gray-300 text-black rounded-md focus:outline-none focus:ring-2 focus:ring-black"
        />
      </div> */}

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6">
        {filtered.map((product) => (
          <div
            key={product.id}
            onClick={() => navigate(`/product/${product.id}`)}
            className="cursor-pointer group"
          >
            <div className="relative aspect-w-1 aspect-h-1 overflow-hidden bg-gray-100 rounded-lg">

            {/* 🔥 ETIQUETA SOLO PARA PACK 3 */}
            {isOnly3Pack(product) && (
              <div className="
                absolute top-2 left-2 z-10
                bg-orange-600 text-white text-[0.7rem]
                sm:text-xs md:text-sm
                font-bold uppercase
                px-2 py-1 rounded-full
                shadow-md tracking-wide
              ">
                10% Descuento
              </div>
            )}

            <img
              src={product.image}
              alt={product.name}
              className="object-cover w-full h-full transition-transform duration-300 group-hover:scale-105"
            />
          </div>
            <h3 className="mt-4 text-lg font-semibold truncate text-center">{product.name}</h3>
           <p className="text-gray-500 text-center">
                ₡{Number(getDefaultPackPrice(product)).toLocaleString()}
              </p>
          </div>
        ))}
      </div>
    </section>
  );
}